<template>
        <header v-if="$route.path==='/home' || $route.path==='/records'" class="layout-header">
            <van-search v-model="searchValue" placeholder="商品検索" shape="round" @click.native="goToSearchPage"/>
        </header>
</template>
<script>
export default {
    name: "HomeRecordsHeader",
    data() {
        return {
            // 头部搜索框的值
            searchValue: ""
        }
    },

    methods: {
        goToSearchPage() {
            console.log("执行goToSearchPage方法进入新的搜索页");
            this.$router.push({path: "/search"});
        }
    }
}
</script>

<style scoped>

</style>